<template>
    <div>
        <v-dialog v-model="socsoDialog" max-width="800px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{$t('statutoryexportcommonused.referencenumberitem')}}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-autocomplete
                            outlined
                            :label="this.$t('alleissocso.socsorefnocode')"
                            type="text"
                            :items="refnumList"
                            v-model="selections[0].socsorefcodeid"
                            @change="changeSocsoRefcodeHandler(selections[0].socsorefcodeid)"
                            dense
                            :rules="[rules.required]"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" >
                        <v-text-field
                            outlined
                            :label="this.$t('alleissocso.socsorefno')"
                            type="text"
                            v-model="selections[0].socsorefnum"
                            dense
                            append-icon=""
                            background-color="#ffeab2"
                            readonly
                           
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6" md="6 mt-n8">
                        <v-autocomplete
                            outlined
                            :label="this.$t('alleissocso.eisrefnocode')"
                            type="text"
                            :items="refnumList"
                            v-model="selections[0].eisrefcodeid"
                            @change="changeEISRefcodeHandler(selections[0].eisrefcodeid)"
                            dense
                            :rules="[rules.required]"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('alleissocso.eisrefno')"
                            type="text"
                            v-model="selections[0].eisrefnum"
                            dense
                            append-icon=""
                            background-color="#ffeab2"
                            readonly
                           
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row> 
                      <v-col cols="12" sm="6" md="6 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('claimrecordlisting.receiptno')"
                            ref="receiptno"
                            type="number"
                            v-model="selections[0].receiptno"
                            dense
                            class="v-input"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6 mt-n8" >
                        <v-text-field
                            outlined
                            :label="this.$t('claimrecordlisting.receiptdate')"
                            type="date"
                            ref = 'receiptdate'
                            v-model="selections[0].receiptdate"
                            dense
                            clearable
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                     <v-col cols="12" sm="6" md="6 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('statutoryexportcommonused.receiptref')"
                            ref="receiptref"
                            type="text"
                            v-model="selections[0].receiptref"
                            dense
                        ></v-text-field>
                    </v-col>
                    
                </v-row>

             
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeSocso">{{$t('button.cancel')}}</v-btn>
              <v-btn color="blue darken-1" text @click="saveSocso">{{$t('button.save')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="editDialog" max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline">{{$t('statutoryexportcommonused.referencenumberitem')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-autocomplete
                            outlined
                            :label="this.$t('alleissocso.socsorefnocode')"
                            :items="refnumList"
                            v-model="selections[0].socsorefcodeid"
                            @change="changeSocsoRefcodeHandler(selections[0].socsorefcodeid)"
                            dense
                            :rules="[rules.required]"
                            readonly
                            append-icon=" "
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" >
                        <v-text-field
                            outlined
                            :label="this.$t('alleissocso.socsorefno')"
                            type="text"
                            v-model="selections[0].socsorefnum"
                            dense
                            append-icon=""
                            background-color="#ffeab2"
                            readonly

                        ></v-text-field>
                    </v-col>
                </v-row>        

                  <v-row>
                    <v-col cols="12" sm="6" md="6 mt-n8">
                        <v-autocomplete
                            outlined
                            :label="this.$t('alleissocso.eisrefnocode')"
                            :items="refnumList"
                            v-model="selections[0].eisrefcodeid"
                            @change="changeEISRefcodeHandler(selections[0].eisrefcodeid)"
                            dense
                            :rules="[rules.required]"
                            readonly
                            append-icon=" "
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('alleissocso.eisrefno')"
                            type="text"
                            v-model="selections[0].eisrefnum"
                            dense
                            append-icon=""
                            background-color="#ffeab2"
                            readonly

                        ></v-text-field>
                    </v-col>
                </v-row>                                                        

                <v-row> 
                      <v-col cols="12" sm="6" md="6 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('claimrecordlisting.receiptno')"
                            type="number"
                            ref="receiptno"
                            v-model="selections[0].receiptno"
                            dense
                            class="v-input"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6 mt-n8" >
                        <v-text-field
                            outlined
                            :label="this.$t('claimrecordlisting.receiptdate')"
                            ref="receiptdate"
                            type="date"
                            v-model="selections[0].receiptdate"
                            dense
                            clearable
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                     <v-col cols="12" sm="6" md="6 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('statutoryexportcommonused.receiptref')"
                            type="text"
                            ref="receiptref"
                            v-model="selections[0].receiptref"
                            dense
                        ></v-text-field>
                    </v-col>
                    
                </v-row>

             
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeSocso">{{$t('button.cancel')}}</v-btn>
              <v-btn color="blue darken-1" text @click="editSocso">{{$t('button.save')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        

        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
:sort-by="['code']"
        >
        <template v-slot:item.action="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="modifyItemHandler(item)"
            >
                mdi-pen
            </v-icon>
            <v-icon
                small
                class="ml-3 mr-2"
                @click="deleteItemHandler(item)"
            >
                mdi-delete
            </v-icon>
        </template>

        </v-data-table>
        </div>
    </div>
</template>

<script>
import compareArray from '../../../util/comparearray';

export default {
    props: {
        parentObject: Object
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required')
            },

            socsoDialog: false,
            editDialog: false,
            detailItem: this.parentObject.detailItem,
            selections: [{
                id: null,
                socsosubrecid: null,
                socsorefcodeid: null,
                eisrefcodeid: null,
                socsorefcode: null, 
                socsorefnum: null, 
                eisrefcode: null,
                eisrefnum: null,
                receiptno: null,
                receiptdate: null ,
                receiptref: null,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                action: 0
            }],

            

            //arrays to store various data objects from db 
            refnums: [],
            refnumList: [],
            months: [1, 2, 3, 4, 5 , 6 , 7 , 8 , 9 , 10, 11 , 12],
            years: [],
            

            //error msg and dialog, check for duplicates vars
            isExisting: false,
            isErr: false,
            errMsg: '',
            isDisabled: false,
        }
    },

    methods: {
        compareArray,

newItem() {
    this.isExisting = false;
    this.modify = false;
    this.resetSelections();
},

        loadYears() {
            for (let i= 0; i < 200; i++) {
                var year = 2020;
                this.years.push(year + i);
            }
        },

        modifyItemHandler(item) {
      
            if(item.action == 2) {
                this.isExisting = true; 
                this.isDisabled = true;    
            }

            this.selections[0] = item;
            this.editDialog = true;

            if (!this.isExisting){
                // duplicate this.detailItem for duplicate checking
                
                //find index 
                
                var index = this.detailItem.findIndex( x => x.refcodeid == item.refcodeid);

                this.detailItem[index].receiptno = item.receiptno;
                this.detailItem[index].receiptdate = item.receiptdate;
                this.detailItem[index].receiptref = item.receiptref;

                //this.resetSelections();

            } else {
                this.selections[0].action = 2;

                if (this.compareArray(this.detailItem, this.selections[0])) {
                    console.log(this.compareArray(this.detailItem, this.selections[0]))
                }
            }

            //this.editDialog = true;
           
        },        

        deleteItemHandler(item) {
            let itemIndex = this.detailItem.indexOf(item);

            this.detailItem.splice(itemIndex, 1);
            this.resetSelections();

            
        },

        closeSocso() {
            this.socsoDialog = false;
            this.editDialog = false;
            this.isErr = false;

            // reset the form fields
            this.resetSelections();
        },

        saveSocso() {

             if (this.selections[0].socsorefcodeid == null)
              {
                this.$dialog.alert(this.$t('alleissocso.fillinthesocsorefno')).then((dialog) => {
                  console.log(dialog);
              });            
            } else if (this.selections[0].eisrefcodeid == null) {
                this.$dialog.alert(this.$t('alleissocso.fillintheeisrefno')).then((dialog) => {
                  console.log(dialog);
              });     
            
            }else {
            this.isErr = false;
       
        
            if (!this.isExisting) {

                this.selections[0].action = 1;

                if (this.detailItem.some( rec => rec.socsorefcodeid  == this.selections[0].socsorefcodeid || 
                rec.eisrefcodeid  == this.selections[0].eisrefcodeid)) {
                        
                        this.errMsg = this.$t('alleissocso.onlyuniqitemallow');
                        this.isErr = true;
                        this.socsoDialog = true; 
                        
                } else {

                        this.selections[0].action = 1;
                        this.detailItem.push(Object.assign({}, this.selections[0]));

                        this.socsoDialog = false;
                        this.$emit('input', this.detailItem);

                         // reset the form fields
                        this.resetSelections();
                    
                    }
        
            } else {
                this.selections[0].action = 2;
                //this.resetSelections();

                if (this.compareArray(this.detailItem, this.selections[0])) {
                    console.log(this.compareArray(this.detailItem, this.selections[0]))
                }
            } 
            }
        },

        editSocso() {
            this.isExisting = false;
            this.editDialog = false;
            this.resetSelections();
            this.isErr =false; 
        },
        
        resetSelections() {
            this.selections = [{
                id: null,
                socsosubrecid: null,
                socsorefcodeid: null,
                eisrefcodeid: null,
                socsorefcode: null, 
                socsorefnum: null,
                eisrefcode: null,
                eisrefnum: null, 
                receiptno: null,
                receiptdate: null,
                receiptref: null,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                action: 0
            }]
        },

 
        loadSocsoRefnum() {
            const vm = this;

            this.$store.dispatch('get', {url: '/refnum/all'})
            .then (res => {
                vm.refnums = res.data.rec;
                
                for (let i = 0; i < vm.refnums.length; i++) {
                    vm.refnumList.push(
                        {   
                            refnum: vm.refnums[i].refnum,
                            text: vm.refnums[i].refcode,
                            value: vm.refnums[i].id
                        }
                    )
                }

            });
        },
         

        changeSocsoRefcodeHandler(id) {
            let item = this.refnums.find(item => item.id == id)
            
            this.selections[0].socsorefcode = item.refcode;
            this.selections[0].socsorefnum = item.refnum;
            
        },

          loadEISRefnum() {
            const vm = this;

            this.$store.dispatch('get', {url: '/refnum/all'})
            .then (res => {
                vm.refnums = res.data.rec;
                
                for (let i = 0; i < vm.refnums.length; i++) {
                    vm.refnumList.push(
                        {   
                            refnum: vm.refnums[i].refnum,
                            text: vm.refnums[i].refcode,
                            value: vm.refnums[i].id
                        }
                    )
                }

            });
        },
         

        changeEISRefcodeHandler(id) {
            let item = this.refnums.find(item => item.id == id)
            
            this.selections[0].eisrefcode = item.refcode;
            this.selections[0].eisrefnum = item.refnum;
            
        },

          
    },

    created() {
        this.loadSocsoRefnum();
        this.loadEISRefnum();
  
    }
}
</script>

<style>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}
</style>